import { Component } from '@angular/core';

@Component({
  templateUrl: './how-we-invest.component.html',
  styleUrls: [
      '../../shared/static-pages.scss',
      'how-we-invest.component.scss',
  ],
  standalone: false
})
export class HowWeInvestComponent { }
